const Headings = {
  baseStyle: {},
  variants: {
    standard: {
      color: "white",
      fontFamily: "heading",
      fontWeight: 500,
      m: 0,
    },
    standardBlack: {
      color: "black",
      fontFamily: "heading",
      fontWeight: 500,
    },
    standardSub: {
      fontFamily: "heading",
      fontWeight: 400,
      fontSize: "1.75em",
    },
    standardMicro: {
      fontFamily: "heading",
      fontWeight: 400,
      fontSize: "1.25em",
    },
    base: {
      color: "black",
      size: ["sm", "md", "lg", "xl", "2xl", "3xl"],
    },
  },
}

export default Headings
